import { useEffect } from 'react';
import { runSyncCheckAction } from '../store/slices/syncCheck/sagas/syncCheckActions';
import useAppDispatch from './useAppDispatch';
import useAppUser from './useAppUser';

// @ts-expect-error TS7034 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
let syncCheckInterval;

const useAppSyncCheck = ({
  isInitInProgress,
}: {
  isInitInProgress: boolean;
}) => {
  const dispatch = useAppDispatch();
  const { isEmployee, isOwner } = useAppUser();

  if (
    (isEmployee || isOwner) &&
    !isInitInProgress &&
    // @ts-expect-error TS7005 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    !syncCheckInterval
  ) {
    dispatch(runSyncCheckAction({}));

    syncCheckInterval = setInterval(() => {
      if (document.hasFocus()) {
        dispatch(runSyncCheckAction({}));
      }
    }, 10000);
  }

  useEffect(() => {
    return () => {
      // @ts-expect-error TS7005 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      if (syncCheckInterval) {
        clearInterval(syncCheckInterval);
      }
    };
  }, []);

  return null;
};

export default useAppSyncCheck;
